import React from 'react'
import {PropTypes} from 'prop-types'

import TopBar from './TopBar'
import NavSideBar from './NavSideBar'
import Content from './Content'
import './layout.scss'

const Layout = props => {
  return (
    <div className="app-layout">
      <TopBar userName={props.userName}></TopBar>
      <div className="app-container">
        <NavSideBar></NavSideBar>

        <Content>{props.children}</Content>
      </div>
    </div>
  )
}

Layout.propTypes = {
  userName: PropTypes.string,
}

export default Layout
